const ARTICLES = "/api/articles";

const exportedObject = {
  ARTICLES
};

export default exportedObject;
